/** Zentrale Query-Keys für TanStack Query — verhindert Tippfehler bei invalidateQueries. */
export const qk = {
  session: ['session'] as const,
  vehicles: ['vehicles'] as const,
  vehicle: (slug: string) => ['vehicle', slug] as const,
  sections: (vehicleSlug: string) => ['vehicle', vehicleSlug, 'sections'] as const,
  section: (vehicleSlug: string, sectionSlug: string) => ['vehicle', vehicleSlug, 'section', sectionSlug] as const,
  tool: (toolId: string) => ['tool', toolId] as const,
  vehicleViews: (slug: string) => ['vehicle', slug, 'views'] as const,
  adminViews: (vehicleId: string) => ['admin', 'views', vehicleId] as const,
  mediaLinks: (targetType: string, targetId: string) => ['admin', 'media-links', targetType, targetId] as const,
  flashcards: (filters: Record<string, string | undefined>) => ['flashcards', filters] as const,
  quiz: (filters: Record<string, string | undefined>) => ['quiz', filters] as const,
  search: (q: string) => ['search', q] as const,
  categories: ['categories'] as const,
  audit: ['admin', 'audit'] as const,
  mediaLibrary: (filters: Record<string, string | undefined>) => ['admin', 'media', filters] as const,
  adminVehicles: ['admin', 'vehicles'] as const,
  adminVehicle: (id: string) => ['admin', 'vehicle', id] as const,
  adminFlashcards: (filters: Record<string, string | undefined>) => ['admin', 'flashcards', filters] as const,
  adminQuiz: (filters: Record<string, string | undefined>) => ['admin', 'quiz', filters] as const,
};
